import { FC } from "react";

import { CircularProgress, Grid2 } from "@mui/material";
import { DataGrid, GridColDef, GridPaginationModel } from "@mui/x-data-grid";

import { IFullClient, IFullClientResponse } from "../../../api/hooks/useFullClients/type.ts";

const columns: GridColDef<IFullClient>[] = [
  { field: "name", headerName: "І'мя", valueGetter: (_, row) => row.name, flex: 1, sortable: false },
  { field: "phoneNumber", headerName: "Телефон", valueGetter: (_, row) => row.phoneNumber, flex: 1, sortable: false },
  { field: "bonus", headerName: "Бонус", valueGetter: (_, row) => row.balance, flex: 1, sortable: false },
  { field: "loyalty", headerName: "Лояльність", valueGetter: (_, row) => `${row.discountPercentage}%`, flex: 1, sortable: false },
  { field: "bookings", headerName: "К-сть бронювань", valueGetter: (_, row) => row.totalBookingsCount, flex: 1, sortable: false },
  { field: "hours", headerName: "К-сть годин", valueGetter: (_, row) => row.totalBookingHours, flex: 1, sortable: false },
  { field: "canceled", headerName: "К-сть видалених", valueGetter: (_, row) => row.totalDeletedBookingsCount, flex: 1, sortable: false },
  { field: "income", headerName: "Дохід", valueGetter: (_, row) => row.totalClientIncome, flex: 1, sortable: false },
  { field: "blackList", headerName: "Чорний список", valueGetter: (_, row) => row.isInBlackList ? 'Так' : 'Ні', flex: 1, sortable: false },
];

type TableProps = {
  data?: IFullClientResponse;
  loading: boolean;
  paginationModel: GridPaginationModel;
  setPaginationModel: (model: GridPaginationModel) => void;
}

const Table: FC<TableProps> = ({ data, loading, paginationModel, setPaginationModel }) => {
  if (!data) return <Grid2 container justifyContent="center">
    <CircularProgress color="secondary" />
  </Grid2>;

  return (
    <div>
      <DataGrid
        loading={loading}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        getRowId={row => row.id}
        rows={data.clients}
        columns={columns}
        rowHeight={70}
        disableColumnMenu
        paginationMode="server"
        rowSelection={false}
        initialState={{ pagination: { rowCount: data.totalCount } }}
        pageSizeOptions={[20, 50]}
      />
    </div>
  );
};

export default Table;
